import PropTypes from 'prop-types'
import React from 'react'

import { Tooltip } from 'react-wot-bootstrap'

import IndustrialResource from 'components/IndustrialResource/IndustrialResource'

import {
    INDUSTRIAL_RESOURCE_DETAILS,
    INDUSTRIAL_RESOURCE_TOOLTIP,
    INDUSTRIAL_RESOURCE_TOOLTIP_ACTIVATE_RESERVES,
    INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL,
    CLICK_TO_OPEN_RESOURCE_JOURNAL,
    INDUSTRIAL_RESOURCE_TOOLTIP_WITH_FINES,
} from './constants'

import { NEGATIVE_IR_BALANCE_HINT } from 'helpers/i18n'

import styles from './StorageTooltip.scss'

export const StorageTooltip = ({ industrialResource, showFooter }) => {
    const hasFines = industrialResource < 0
    let volatile_content
    const irValue = (
        <IndustrialResource
            value={industrialResource}
            notEnough={hasFines}
            small
            iconAtLeft
        />
    )

    if (hasFines) {
        volatile_content = (
            <div>
                <p className={styles.message}>
                    {INDUSTRIAL_RESOURCE_TOOLTIP_WITH_FINES(irValue)}
                </p>
                <p className={styles.message}>
                    {INDUSTRIAL_RESOURCE_TOOLTIP_ACTIVATE_RESERVES}
                </p>
            </div>
        )
    } else {
        volatile_content = (
            <div>
                <p className={styles.message}>
                    {INDUSTRIAL_RESOURCE_TOOLTIP(irValue)}
                </p>
            </div>
        )
    }

    return (
        <Tooltip id={StorageTooltip.id}>
            <div className={styles.content}>
                <p className={styles.subtitle}>
                    {INDUSTRIAL_RESOURCE_DETAILS}
                </p>
                {volatile_content}
                <div className={styles.divider} />
                <p className={styles.message}>
                    {hasFines ?
                        NEGATIVE_IR_BALANCE_HINT :
                        INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL
                    }
                </p>
                {showFooter && (
                    <p className={styles.message}>
                        {CLICK_TO_OPEN_RESOURCE_JOURNAL}
                    </p>
                )}
            </div>
        </Tooltip>
    )
}

StorageTooltip.id = 'clan_panel_industrial_resource_tooltip'

StorageTooltip.propTypes = {
    industrialResource: PropTypes.number.isRequired,
    showFooter: PropTypes.bool,
}

StorageTooltip.defaultProps = {
    showFooter: false,
}

export default StorageTooltip



// WEBPACK FOOTER //
// ./containers/ClanPanel/components/Storage/StorageTooltip.jsx